import * as Alert from './alert';
import { request } from './api';

/**
 * Action constants
 */
export const RISK_PROFILE_REQUEST = 'RISK_PROFILE_REQUEST';
export const RISK_PROFILE_SUCCESS = 'RISK_PROFILE_SUCCESS';
export const RISK_PROFILE_FAILURE = 'RISK_PROFILE_FAILURE';
export const RISK_PROFILE_MONITORING_SUCCESS =
  'RISK_PROFILE_MONITORING_SUCCESS';
export const RISK_PROFILE_MONITORING_FAILURE =
  'RISK_PROFILE_MONITORING_FAILURE';

export const SET_SELECTED_PORTFOLIO = 'SET_SELECTED_PORTFOLIO';

export function setSelectedPortfolio(portfolioName) {
  return {
    type: SET_SELECTED_PORTFOLIO,
    portfolioName,
  };
}
export const SET_RISK_PROFILE = 'SET_RISK_PROFILE';
export const SET_MONITORED_ACCOUNTS = 'SET_MONITORED_ACCOUNTS';
export const UPDATE_RISK_PROFILE_MONITORING_SUCCESS =
  'UPDATE_RISK_PROFILE_SUCCESS';
export const UPDATE_RISK_PROFILE_MONITORING_FAILURE =
  'UPDATE_RISK_PROFILE_FAILURE';

export const setRiskProfile = (riskProfileId) => ({
  type: SET_RISK_PROFILE,
  payload: riskProfileId,
});

export const setMonitoredAccounts = (accountIds) => ({
  type: SET_MONITORED_ACCOUNTS,
  payload: accountIds,
});

export function createRiskProfileMonitoring(params) {
  return (dispatch) =>
    dispatch(
      request('post', '/auth/user/risk-monitoring/create/', { body: params })
    ).then(
      (data) => {
        dispatch({
          type: UPDATE_RISK_PROFILE_MONITORING_SUCCESS,
          payload: data,
        });
      },
      (error) => {
        dispatch({
          type: UPDATE_RISK_PROFILE_MONITORING_FAILURE,
          payload: error,
        });
        dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
}

export function getRiskProfileMonitoring() {
  return (dispatch) => {
    dispatch({ type: RISK_PROFILE_REQUEST });
    return dispatch(request('get', '/auth/user/risk-monitoring/')).then(
      (data) => {
        dispatch({ type: RISK_PROFILE_MONITORING_SUCCESS, payload: data });
        return data;
      },
      (error) => {
        if (error.data.detail !== 'User did not assign a risk profile.') {
          dispatch({ type: RISK_PROFILE_MONITORING_FAILURE });
          return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
        }
        return null;
      }
    );
  };
}

export function updateRiskProfileMonitoring(params) {
  return (dispatch) =>
    dispatch(
      request('put', '/auth/user/risk-monitoring/', { body: params })
    ).then(
      (data) => {
        dispatch({
          type: UPDATE_RISK_PROFILE_MONITORING_SUCCESS,
          payload: data,
        });
      },
      (error) => {
        dispatch({
          type: UPDATE_RISK_PROFILE_MONITORING_FAILURE,
          payload: error,
        });
        dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
}

function parseErr(err) {
  if (err.non_field_errors) {
    return err.non_field_errors[0];
  }

  if (typeof err === 'string') {
    return err;
  }

  return err.msg || err.detail || err.error || 'Server Offline';
}

export function getRiskProfile() {
  return (dispatch) => {
    dispatch({ type: RISK_PROFILE_REQUEST });

    return dispatch(request('get', '/auth/user/riskprofile/')).then(
      (data) => {
        dispatch({ type: RISK_PROFILE_SUCCESS, payload: data });
      },
      (error) => {
        dispatch({ type: RISK_PROFILE_FAILURE });
        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function deleteRiskProfileMonitoring() {
  return (dispatch) => {
    dispatch({ type: RISK_PROFILE_REQUEST });

    return dispatch(request('delete', '/auth/user/risk-monitoring/')).then(
      (data) => {
        dispatch({ type: RISK_PROFILE_MONITORING_SUCCESS, payload: data });
      },
      (error) => {
        dispatch({ type: RISK_PROFILE_MONITORING_FAILURE });
        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}
